import type { ElementType, ReactNode } from "react";
import { IconButton, type IconButtonProps } from "@dea-web/ui";
import { DocumentCopy } from "@dea-web/icons";

interface SbuxContentButtonProps {
  iconName?: ElementType;
  icon?: ReactNode;
  disabled?: boolean;
  handleClick?: () => void;
  color?: IconButtonProps["color"];
  iconSize?: string | number;
}

const SbuxContentButton = ({
  iconName: Icon,
  icon,
  disabled = false,
  handleClick,
  color,
  iconSize,
}: SbuxContentButtonProps) => {
  const renderIcon = () => {
    if (icon) return icon;
    const IconComponent = Icon ?? DocumentCopy;
    return <IconComponent sx={{ fontSize: iconSize }} />;
  };

  return (
    <IconButton
      disabled={disabled}
      onClick={handleClick}
      color={color}
      sx={{
        "&:focus": { outline: 0 },
        p: 0,
        pl: "5px",
      }}
    >
      {renderIcon()}
    </IconButton>
  );
};

export default SbuxContentButton;
